import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    jobPostings: [],
    archivedJobPostings: [],
    jobBoards: [],
    tableLoading: false,
    currentPage: 1,
    perPage: 5,
    trackingId: null,
    searchQuery: "",
    total: 0,
    selectedRow: null,
    selectedRowJobBoard: null,
  },
  actions,
  mutations,
};
